/**
 * CyberSells Reveal System
 * Scroll-triggered animations using IntersectionObserver
 * Respects prefers-reduced-motion
 */

(function() {
  'use strict';

  class CyberReveal {
    constructor() {
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.observer = null;
      this.elements = [];
      
      this.init();
    }

    init() {
      // Skip if user prefers reduced motion
      if (this.prefersReducedMotion) {
        this.revealAll();
        return;
      }

      // Find all elements with data-cs-reveal
      this.elements = document.querySelectorAll('[data-cs-reveal]');
      
      if (this.elements.length === 0) {
        return;
      }

      // Create observer
      this.createObserver();
      
      // Observe all reveal elements
      this.elements.forEach(el => {
        this.observer.observe(el);
      });
    }

    createObserver() {
      const options = {
        root: null, // viewport
        rootMargin: '0px 0px -10% 0px', // trigger slightly before element enters viewport
        threshold: 0.1 // trigger when 10% visible
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.reveal(entry.target);
          }
        });
      }, options);
    }

    reveal(element) {
      // Add revealed class
      element.classList.add('cs-revealed');
      
      // Unobserve after revealing (one-time animation)
      if (this.observer) {
        this.observer.unobserve(element);
      }
      
      // Dispatch custom event for other scripts to hook into
      const event = new CustomEvent('cs:revealed', {
        detail: { element }
      });
      document.dispatchEvent(event);
    }

    revealAll() {
      // Immediately reveal all elements (for reduced motion)
      this.elements = document.querySelectorAll('[data-cs-reveal]');
      this.elements.forEach(el => {
        el.classList.add('cs-revealed');
      });
    }

    // Public method to manually reveal an element
    static revealElement(element) {
      if (element) {
        element.classList.add('cs-revealed');
      }
    }

    // Public method to reset an element
    static resetElement(element) {
      if (element) {
        element.classList.remove('cs-revealed');
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.CyberReveal = new CyberReveal();
    });
  } else {
    window.CyberReveal = new CyberReveal();
  }

  // Export static methods
  window.CyberReveal = window.CyberReveal || {};
  window.CyberReveal.revealElement = CyberReveal.revealElement;
  window.CyberReveal.resetElement = CyberReveal.resetElement;

})();
